import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-safety-observations-view-incidents',
  templateUrl: './safety-observations-view-incidents.component.html',
  styleUrls: ['./safety-observations-view-incidents.component.scss']
})
export class SafetyObservationsViewIncidentsComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
